import {Box, makeStyles, Typography} from '@material-ui/core';
import {useIntl} from 'react-intl';
import {formatAsDollars} from '@generic/functions/formatters';
import sum from 'lodash/sum';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.gray[300],
    padding: '0.875rem 2rem',
  },
  topText: {
    marginBottom: '1rem',
  },
}));

const DISCOUNT_AS_DECIMAL = 0.5;

export default function EVPhaseInRateDisclaimer({rateCalculator}) {
  const classes = useStyles();
  const {formatMessage} = useIntl();

  const evPhaseInRateElements = rateCalculator.rateElements({
    ids: ['evPhaseInRate'],
  });
  const discountSubtotal = sum(evPhaseInRateElements.map((el) => el.annualCost()));

  const savingsAmount = Math.round(discountSubtotal * DISCOUNT_AS_DECIMAL);
  const monthlySavingsAmount = Math.round(savingsAmount / 12);

  return (
    <Box mt={6} className={classes.root}>
      <Typography className={classes.topText} align="center">
        {formatMessage(
          {id: 'evPhaseInRate.disclaimer'},
          {
            percent: DISCOUNT_AS_DECIMAL * 100,
            amount: formatAsDollars(monthlySavingsAmount),
            bold: (str) => <b>{str}</b>,
            link: (
              <a href="https://www.coned.com/EVphaseinrates" target="_blank" rel="noreferrer">
                www.coned.com/EVphaseinrates
              </a>
            ),
          }
        )}
      </Typography>
    </Box>
  );
}
